import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface TransactionFeesToggleRequest {
  passTransactionFeesToCustomers: boolean;
  cardTransactionFees: string;
  cardFixedFee: string;
  achTransactionFees: string;
  updateInvoices: boolean;
  excludedParentIds: Array<string>;
}

export interface TransactionFeesToggleResponse {
  passTransactionFeesToCustomers: boolean;
  cardTransactionFees?: string;
  cardFixedFee?: string;
  achTransactionFees?: string;
  updateInvoices?: boolean;
  /** Whether the studio overrides Stripe Dashboard payment method settings. */
  bypassStripePaymentMethodConfig?: boolean;
  /** True when Link was (or already is) disabled because pass-along + override. */
  stripeLinkDisabled?: boolean;
  message: string;
}

// Toggle transaction fees settings
export const toggleTransactionFeesAPI = async (
  data: TransactionFeesToggleRequest,
): Promise<TransactionFeesToggleResponse> => {
  const response = await baseAPI.put<TransactionFeesToggleResponse>(
    '/transaction-fees/settings',
    data,
  );
  return response.data;
};

// React Query hook for toggling settings
export const useToggleTransactionFees = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: toggleTransactionFeesAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRANSACTION_FEES_SETTINGS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ALLOWED_PAYMENT_METHODS],
      });
    },
  });
};
